import { useCallback } from 'react';
import { useAxios } from '../axios';
import { GetPortParams, Port } from './port.types';

export const useGetPort = () => {
  const [{ data, loading }, axiosFetch] = useAxios<{
    result: { data: Port[]; count: number };
  }>({
    method: 'GET',
  });

  const getPort = useCallback(
    ({
      filterText = '',
      pageNumber = 1,
      resultSize = 25,
      withSystemUsers = false,
    }: GetPortParams) =>
      axiosFetch({
        url: '/port',
        params: {
          filterText,
          pageNumber,
          resultSize,
          withSystemUsers,
        },
      }),
    [axiosFetch],
  );

  return {
    data: data?.result.data,
    loading,
    getPort,
  };
};
